import React from 'react';

export interface SkeletonBlockProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Apply horizontal shimmer animation (default true) */
  shimmer?: boolean;
}

const SkeletonBlock: React.FC<SkeletonBlockProps> = ({
  className = '',
  shimmer = true,
  ...props
}) => {
  // Generated CSS puts .rounded-md after .rounded-full, so the default must yield to any caller radius.
  const hasOwnRadius = /(^|\s)rounded(-|\s|$)/.test(className);
  const classes = [
    hasOwnRadius ? '' : 'rounded-md',
    shimmer ? 'skeleton-shimmer' : 'bg-neutral-100',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return <div className={classes} {...props} />;
};

export default SkeletonBlock;
